<template>
  <div class="sdk-universal-config-manage-page">
    <basic-container>
      <div class="search-form-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-select v-model="formInline.ptype" clearable placeholder="参数项">
              <el-option v-for="item in sdkCategoryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input clearable v-model="formInline.search" placeholder="配置名称/KEY"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch"
              v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_SEARCH'">搜索</el-button>
            <el-button type="primary" @click="openDialog" plain
              v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_ADD'">新增</el-button>
            <el-button type="danger" @click="handleDelete" plain
              v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'">删除</el-button>
          </el-form-item>
        </el-form>
      </div>

      <avue-crud ref="crud" :option="option" :page.sync="page" :table-loading="loading" @on-load="getList"
        @selection-change="handleSelectionChange" :data="data">
        <template slot-scope="scope" slot="menu">
          <el-button size="small" @click="handleEdit(scope.row)" type="text" icon="el-icon-edit"
            v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_EDIT'">编辑</el-button>
          <el-button size="small" type="text" @click="handleDeleteRow(scope.row)" icon="el-icon-delete"
            v-auth="'APPS_SDK_UNIVERSAL_CONFIG_INDEX_DEL'">删除</el-button>
          <!-- <el-button size="small" type="text"   >飞书提醒</el-button>
          <el-button size="small" type="text" @click="getLog(scope.row)">日志</el-button> -->
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog :title="isEdit ? '编辑' : '新增'" append-to-body :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible" width="30%" @close="onDialogClose">
      <div class="dialog-content-wrap">
        <el-form :model="formModel" :rules="rules" ref="editForm" size="small" label-width="100px">
          <el-form-item label="配置分类" prop="ptype">
            <el-select v-model="formModel.ptype" placeholder="请选择参数项配置">
              <el-option v-for="item in sdkCategoryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参数项名称" prop="pname">
            <el-input v-model="formModel.pname"></el-input>
          </el-form-item>
          <el-form-item label="参数项ID" prop="pkey">
            <el-input v-model="formModel.pkey"></el-input>
          </el-form-item>
          <el-form-item label="默认值" prop="pdefault">
            <el-input v-model="formModel.pdefault"></el-input>
          </el-form-item>
          <el-form-item label="参数值" prop="pvalue">
            <el-input type="textarea" :rows="4" v-model="formModel.pvalue"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <LogDialog ref="logDialog"></LogDialog>
  </div>
</template>
<script>
import { deletePlayConfig, getPlayConfigList, savePlayConfig, updatePlayConfig } from '@/api/apps/playConfig/templateConfig';
import { getDictionary } from "@/api/system/dict";
import { getToken } from "@/util/auth";
import { merge } from "@/util/common";
import LogDialog from "./log.vue";
import options from "./option";
export default {
  name: "SdkUniversalConfigPage",
  components: {
    LogDialog
  },
  data() {
    return {
      sdkCategoryOptions: [],
      selectIds: "",
      isEdit: false,
      currentRow: null,
      formInline: {
        ptype: "",
        search: ""
      },
      typeOptions: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      visible: false,
      formModel: {
        ptype: "",
        pkey: "",
        pdefault: "",
        pname: "",
        pvalue: ""
      },
      rules: {
        ptype: [
          { required: true, message: "请选择参数项配置", trigger: "blur" }
        ],
        pname: [{ required: true, message: "参数项名称", trigger: "blur" }],
        pvalue: [{ required: true, message: "请输入参数值", trigger: "blur" }],
        pdefault: [{ required: true, message: "请输入默认值", trigger: "blur" }],
        pkey: [{ required: true, message: "请输入参数项ID", trigger: "blur" }]
      },
      params: {},
      loading: false,
      data: [],
      option: {}
    };
  },
  created() {
    this.option = options(this);

    this.headers = { "Lebo-Auth": "bearer " + getToken() };
    getDictionary({ code: "player-config" }).then(res => {
      console.log("开始查询数据---", res);
      this.sdkCategoryOptions = res.data.data.map(r => {
        return { label: r.dictValue, value: Number(r.dictKey) };
      });
    });
  },
  methods: {
    /** 操作日志 */
    getLog() {
      this.$refs.logDialog.show();
    },
    handleSearch() {
      this.page.currentPage = 1;
      this.getList();
    },
    // 获取数据
    handleSelectionChange(selection) {
      this.selectIds = selection.map(item => item.id).join(",");
    },
    getList() {
      const query = merge({}, this.formInline, {
        current: this.page.currentPage,
        size: this.page.pageSize
      });
      getPlayConfigList(query).then(res => {
        console.log("getPlayConfigList------", res);
        if (res.status === 200) {
          const data = res.data;
          this.data = data.records;
          this.page.total = data.total;
        }
      });
    },
    clearData() {
      for (let key of Object.keys(this.formModel)) {
        this.formModel[key] = "";
      }
    },
    openDialog() {
      this.visible = true;
    },
    // 编辑数据
    handleEdit(row) {
      this.currentRow = row;
      for (let key of Object.keys(this.formModel)) {
        this.formModel[key] = row[key];
      }
      this.isEdit = true;
      this.visible = true;
    },
    onDialogClose() {
      this.isEdit = false;
      this.visible = false;
      this.currentRow = null;
      this.$refs["editForm"].clearValidate();
      this.clearData();
    },
    // 保存数据
    handleSubmit() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          const data = merge({}, this.formModel);
          let api = savePlayConfig;
          if (this.isEdit) {
            data.id = this.currentRow.id;
            api = updatePlayConfig;
          }
          // this.sdkCategoryOptions.forEach(item => {
          //   if (item.dictKey == data.categoryCode) {
          //     data.categoryName = item.dictValue;
          //   }
          // });

          api(data).then(res => {
            if (res.data.code == 200) {
              this.handleSuccess();
            }
          });
        }
      });
    },
    // 处理保存数据成功
    handleSuccess() {
      this.visible = false;
      this.$message({
        type: "success",
        message: "保存成功!"
      });
      this.getList();
    },
    // 删除数据
    handleDeleteRow(row) {
      this.selectIds = row.id;
      this.handleDelete();
    },
    // 删除数据
    handleDelete() {
      if (this.selectIds === "") {
        this.$message.error("请选择要删除的数据");
        return;
      }
      this.$confirm("是否确认删除选择的记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deletePlayConfig(this.selectIds).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.selectIds = "";
            this.getList();
            this.getChannelOptions();
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
.a {
  color: red;
}

.el-tooltip__popper {
  max-width: 80% !important;
}
</style>
